import { vars } from 'src/core/themes';
import { CrossIcon } from 'src/svgs/Viagogo';
import { getFormattedBytesSize } from 'src/utils/format';

import * as styles from './AttachmentsPanel.css';

export type AttachmentInfo = {
  attachmentId: string;
  name: string;
  size?: number;
  content?: string;
  contentType?: string;
};

export const AttachmentDisplay = ({
  attachmentInfo,
  showDelete,
  onDeleteClicked,
}: {
  attachmentInfo: AttachmentInfo;
  showDelete: boolean;
  onDeleteClicked?: (attachment: AttachmentInfo) => void;
}) => {
  return (
    <div className={styles.attachmentDisplay}>
      <div className={styles.attachmentInfoDisplay}>
        <div className={styles.fileName}>{attachmentInfo.name}</div>
        {attachmentInfo.size != null && (
          <div className={styles.fileSize}>
            {getFormattedBytesSize(attachmentInfo.size, 2, false)}
          </div>
        )}
      </div>
      {showDelete && (
        <div>
          <CrossIcon
            size={vars.iconSize.s}
            onClick={() => onDeleteClicked?.(attachmentInfo)}
          />
        </div>
      )}
    </div>
  );
};
